import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { generateUuid } from '../utils/ids';
import { useIdleTimeout, usePrevious } from '../hooks';
import { HOUR } from '../constants/time';

import { useTypedSelector } from 'state';
import { updateSessionId } from 'state/app-state/reducer';

export function SessionId() {
  const currentUserId = useTypedSelector(state => state.currentUser.id);
  const { idle, start, stop } = useIdleTimeout(HOUR);
  const prevIdle = usePrevious(idle);

  const dispatch = useDispatch();

  const dispatchUpdate = useCallback(() => {
    dispatch(updateSessionId(generateUuid()));
  }, [dispatch]);

  useEffect(() => {
    if (currentUserId) {
      dispatchUpdate();
      start();
    } else {
      stop();
    }
  }, [currentUserId, dispatch, dispatchUpdate, start, stop]);

  useEffect(() => {
    // true -> false
    if (prevIdle && !idle) {
      dispatchUpdate();
    }
  }, [dispatchUpdate, idle, prevIdle]);

  return null;
}
